import { UUID } from '@cmg/common';
import { useMemo } from 'react';
import { useParams } from 'react-router-dom';

import { OfferingType } from '../../../../graphql';
import { useOfferingSetup_ConfigurationRoute_OrderBookConfigurationQuery } from '../graphql/__generated__';

export function useConfigurationRouteSettings() {
  const { offeringId = '' } = useParams<{ offeringId: UUID }>();

  const { data } = useOfferingSetup_ConfigurationRoute_OrderBookConfigurationQuery({
    skip: !offeringId,
    variables: { offeringId },
  });

  const offeringType = data?.privateOfferings?.items?.[0]?.type;

  const withOrderBookConfiguration = useMemo(
    () => offeringType === OfferingType.Ipo || offeringType === OfferingType.Convertible,
    [offeringType]
  );

  return { withOrderBookConfiguration };
}
